module.exports = __webpack_public_path__ + "static/media/logo.8ef42ae9.svg";